/* eslint-disable */
function getHiddenProp() {
  var prefixes = ['webkit','moz','ms','o'];
  
  // if 'hidden' is natively supported just return it
  if ('hidden' in document) return 'hidden';
  
  // otherwise loop over all the known prefixes until we find one
  for (var i = 0; i < prefixes.length; i++){
      if ((prefixes[i] + 'Hidden') in document) 
          return prefixes[i] + 'Hidden';
  }

  // otherwise it's not supported
  return null
}

function getVisibilityState() {
  var prefixes = ['webkit', 'moz', 'ms', 'o']
  if ('visibilityState' in document) return 'visibilityState'
  for (var i = 0; i < prefixes.length; i++) {
    if ((prefixes[i] + 'VisibilityState') in document) {
      return prefixes[i] + 'VisibilityState'
    }
  }
  // otherwise it's not supported
  return null
}

function isHidden() {
  var prop = getHiddenProp()
  if (!prop) return false
  
  return document[prop]
}

export function initPageVisible(callback) {
  var visProp = getHiddenProp();
  if (visProp) {
    var evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange'
    document.addEventListener(evtname, callback ,false)
  }
}

export function destroyPageVisible(callback) {
  var visProp = getHiddenProp();
  if (visProp) {
    var evtname = visProp.replace(/[H|h]idden/, '') + 'visibilitychange'
    document.removeEventListener(evtname, callback ,false)
  }
}


// WEBPACK FOOTER //
// ./src/utils/pageVisible.js